export const contactsHeaderTitles = {
  title: 'Contactos',
  orderBtn: 'Encargar',
};
